import { SearchBar } from '@/components/Common';
import { DataTable } from '@/components/Ui';
import { useUsersList } from '@/components/Views/Users/useUsersList';
import { UserDetail } from './UserDetail';
import filterIconActive from '@/assets/icons/filterIconActive.svg';
import filterIcon from '@/assets/icons/filterIcon.svg';
import FilterUser from './FilterUser';

export const UsersList = () => {
  const {
    columns,
    formattedData,
    lodingDataList,
    handleSearch,
    userDetail,
    usersListlimit,
    setUsersListLimit,
    usersData,
    setUsersListPage,
    usersListPage,
    filterSelections,
    setIsOpenFilter,
  } = useUsersList();

  return (
    <div className="h-screen">
      {userDetail && <UserDetail user={userDetail} />}
      <FilterUser />
      <div>
        <div className="flex items-center bg-[#232323] py-4 pl-7 rounded-[8px]">
          <SearchBar
            type="tel"
            maxLength={9}
            placeholder="Rechercher par numéro (ex: 771234567)"
            handleChange={(e) => handleSearch(e.target.value || '')}
            className="!w-[400px]"
          />
          <div className="relative">
            {Object.keys(filterSelections).length > 0 && (
              <span className="absolute -top-[7px] -right-[7px] text-black text-[10px] size-[20px] bg-primary rounded-full flex items-center justify-center font-semibold">
                {Object.keys(filterSelections).length}
              </span>
            )}
            <div className="ml-[11px] size-[45px] bg-[#2D2D2D] rounded-[8px] flex items-center justify-center">
              <img
                src={
                  Object.keys(filterSelections).length > 0
                    ? filterIconActive
                    : filterIcon
                }
                alt="filter"
                className="cursor-pointer"
                onClick={() => setIsOpenFilter(true)}
              />
            </div>
          </div>
        </div>
        <DataTable
          columns={columns}
          value={formattedData || []}
          loading={lodingDataList}
          withPaginator={true}
          listlimit={usersListlimit}
          currentPage={usersListPage}
          limitHandler={setUsersListLimit}
          currentPageHandler={setUsersListPage}
          countTotal={usersData?.total}
        />
      </div>
    </div>
  );
};
